import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, CircularProgress, Card, CardContent } from "@mui/material";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import ShareIcon from "@mui/icons-material/Share";
import BottomNav from "../../components/Bottom nav/BottomNav";
import useCommonQuery from "../../store/common/useCommonQuery";
import noPic from "../../assets/no-pic.png";
import "./ArivumAarogyavum.css";

const ArivumAarogyavumProducts = () => {
  const history = useHistory();

  // Get subcategory ID from URL params
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  const { data: extraProducts, isLoading: isLoadingProducts } = useCommonQuery.Get_extra_products({
    extra_sub_category: selectedSubCategory,
    search: "",
    limit: 200,
    offset: 0,
  });

  console.log('🔍 Extra Products Data:', JSON.stringify(extraProducts, null, 2));
  console.log('📊 Loading Products:', isLoadingProducts);
  console.log('🎯 Selected SubCategory:', selectedSubCategory);

  const handleProductClick = (product) => {
    if (product.youtube_link) {
      window.open(product.youtube_link, '_blank');
    } else {
      console.log('❌ No link found for this product');
      alert('No video link available for this product.');
    }
  };

  const handleBack = () => {
    history.push('/arivum-aarogyavum');
  };

  // Get subcategory name from localStorage or pass via state
  const getSubCategoryName = () => {
    const name = localStorage.getItem('selectedSubCategoryName');
    return name || "Products";
  };

  // Get subcategory ID from URL params or localStorage
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const subCategoryId = urlParams.get('category') || localStorage.getItem('selectedSubCategory');
    if (subCategoryId) {
      setSelectedSubCategory(subCategoryId);
    }
  }, []);

  return (
    <div>
      {/* Header bar */}
      <div className="arivum-header">
        <div className="arivum-header-inner">

          {/* Left cluster: [ Home ] [ Back ] */}
          <div className="arivum-header-left">
            <button className="arivum-nav-btn" onClick={() => history.push('/')} aria-label="Home">
              <div className="arivum-nav-btn-glow" />
              <HomeIcon style={{ fontSize: 15, color: "#fff", position: "relative", zIndex: 1 }} />
            </button>
            <button className="arivum-nav-btn" onClick={() => history.goBack()} aria-label="Back">
              <div className="arivum-nav-btn-glow" />
              <ArrowBackIcon style={{ fontSize: 15, color: "#fff", position: "relative", zIndex: 1 }} />
            </button>
          </div>

          <Typography className="arivum-products-heading" style={{ color: "#333", fontWeight: "700" }}>
            {getSubCategoryName()}
          </Typography>

          {/* Share button — matching crystal square */}
          <button className="arivum-nav-btn" onClick={() => {
            if (navigator.share) {
              navigator.share({
                title: getSubCategoryName(),
                text: `${getSubCategoryName()} - എല്ലാവർക്കുമുള്ള അറിവും ആരോഗ്യം`,
                url: window.location.href,
              });
            } else {
              alert("Share is not supported on this browser.");
            }
          }} aria-label="Share">
            <div className="arivum-nav-btn-glow" />
            <ShareIcon style={{ fontSize: 15, color: "#fff", position: "relative", zIndex: 1 }} />
          </button>

        </div>
      </div>

      {/* Main Content */}
      <div className="arivum-container">
        <div className="arivum-content-wrapper">
          {isLoadingProducts ? (
            <Box sx={{ display: "flex", justifyContent: "center", padding: "40px" }}>
              <CircularProgress />
            </Box>
          ) : (
            <div className="arivum-products-grid">
              {extraProducts?.data?.results?.map((product) => (
                <div
                  key={product.id}
                  className="arivum-item-card"
                  onClick={() => handleProductClick(product)}
                  style={{ cursor: product.youtube_link ? "pointer" : "default" }}
                >
                  <div className="arivum-image-wrapper">
                    <img
                      src={product.image || noPic}
                      alt={product.name}
                      className="arivum-image"
                    />
                    <div className="arivum-image-shadow"></div>
                  </div>
                  <div className="arivum-label-wrapper">
                    <Typography className="arivum-label">
                      {product.name}
                    </Typography>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <BottomNav />
    </div>
  );
};

export default ArivumAarogyavumProducts;
